import React from "react";
import { Typography, Box, Stack } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const SessionExpired: React.FC = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f9fafb"
      px={2}
    >
      <Stack spacing={2} alignItems="center" textAlign="center">
        <WarningAmberIcon color="error" sx={{ fontSize: 72 }} />

        <Typography variant="h5" fontWeight="600" color="text.primary">
          Session Expired
        </Typography>

        <Typography variant="body1" color="text.secondary">
          This session is no longer active.  
          Please reopen the link from your email to continue the preboarding process.
        </Typography>
      </Stack>
    </Box>
  );
};

export default SessionExpired;
